// source: attributes.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.pb.Attributes', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.pb.Attributes = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.pb.Attributes, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.pb.Attributes.displayName = 'proto.pb.Attributes';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.pb.Attributes.prototype.toObject = function(opt_includeInstance) {
  return proto.pb.Attributes.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.pb.Attributes} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Attributes.toObject = function(includeInstance, msg) {
  var f, obj = {
    access: jspb.Message.getBooleanFieldWithDefault(msg, 1, false),
    aaaaccess: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    approveaccess: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
    certificateaccess: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    newtaskfullaccess: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    spacesaccess: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    certmakeraccess: jspb.Message.getBooleanFieldWithDefault(msg, 7, false),
    imagemakeraccess: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    coolaccess: jspb.Message.getBooleanFieldWithDefault(msg, 9, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.pb.Attributes}
 */
proto.pb.Attributes.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.pb.Attributes;
  return proto.pb.Attributes.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.pb.Attributes} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.pb.Attributes}
 */
proto.pb.Attributes.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAccess(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAaaaccess(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setApproveaccess(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCertificateaccess(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNewtaskfullaccess(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSpacesaccess(value);
      break;
    case 7:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCertmakeraccess(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setImagemakeraccess(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setCoolaccess(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.pb.Attributes.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.pb.Attributes.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.pb.Attributes} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.pb.Attributes.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccess();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
  f = message.getAaaaccess();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getApproveaccess();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getCertificateaccess();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNewtaskfullaccess();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getSpacesaccess();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getCertmakeraccess();
  if (f) {
    writer.writeBool(
      7,
      f
    );
  }
  f = message.getImagemakeraccess();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getCoolaccess();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
};


/**
 * optional bool Access = 1;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getAccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setAccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * optional bool AaaAccess = 2;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getAaaaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setAaaaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool ApproveAccess = 3;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getApproveaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setApproveaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional bool CertificateAccess = 4;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getCertificateaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setCertificateaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool NewTaskFullAccess = 5;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getNewtaskfullaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setNewtaskfullaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool SpacesAccess = 6;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getSpacesaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setSpacesaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool CertMakerAccess = 7;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getCertmakeraccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 7, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setCertmakeraccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 7, value);
};


/**
 * optional bool ImageMakerAccess = 8;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getImagemakeraccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setImagemakeraccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional bool CoolAccess = 9;
 * @return {boolean}
 */
proto.pb.Attributes.prototype.getCoolaccess = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.pb.Attributes} returns this
 */
proto.pb.Attributes.prototype.setCoolaccess = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


goog.object.extend(exports, proto.pb);
